import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { DDDSoundNames, DDDSpineNames } from "../../../../assetsLoader/DDDAssetsNames";
import { DDDFreespinIntroScreen } from "../freespin/DDDFreespinIntroScreen";

export class DDDSuperFreespinIntroScreen extends DDDFreespinIntroScreen {
    constructor(parentContainer: AbstractView) {
        super(parentContainer, `DDDSuperFreespinIntroScreen`);
    }

    protected getSpineName(): string {
        return DDDSpineNames.FS_INTRO;
    }

    protected override getTweenName(): string {
        return `deaderspinintro`;
    }

    protected getIntroStartSoundName(): string {
        return DDDSoundNames.SFS_INTRO_START;
    }

    protected getIntroLoopSoundName(): string {
        return DDDSoundNames.SFS_INTRO_LOOP;
    }
}
